export const featuredTestimonials = [
  {
    initials: 'MR',
    text: 'Me ahorró muchísimo tiempo. Llegué al lunes con todo listo y sin dar vueltas. Muy recomendable.',
    author: 'Marcos R.',
    role: 'Coach de Funcional · México',
    bg: 'bg-blue-600',
  },
  {
    initials: 'CP',
    text: 'Tenía mis dudas antes de comprarlo, pero me sorprendió. Con las tres versiones manejo grupos mixtos sin problema.',
    author: 'Carolina P.',
    role: 'Instructora · Colombia',
    bg: 'bg-sky-600',
  },
  {
    initials: 'DG',
    text: 'Planifiqué las clases con progresiones reales para mis alumnos y se nota. Lo recomiendo sin dudar.',
    author: 'Diego G.',
    role: 'Profe de Box · Perú',
    bg: 'bg-indigo-600',
  },
]

export const coachTestimonials = [
  {
    initials: 'LM',
    name: 'Luciana M.',
    location: 'Chile',
    product: 'Compró el MEGAPACK',
    text: 'Antes llegaba agotada al lunes. Ahora abro el tomo y en 5 minutos tengo la clase armada.',
    bg: 'bg-blue-600',
  },
  {
    initials: 'JP',
    name: 'Juan P.',
    location: 'Colombia',
    product: 'Compró el MEGAPACK',
    text: 'Lo compré con algo de desconfianza y me sorprendió: está mucho más completo de lo que esperaba.',
    bg: 'bg-sky-600',
  },
  {
    initials: 'VR',
    name: 'Valeria R.',
    location: 'México',
    product: 'Compró el MEGAPACK',
    text: 'Los warm-ups y los cierres me salvaron. Se nota que la clase tiene orden de principio a fin.',
    bg: 'bg-indigo-600',
  },
  {
    initials: 'FA',
    name: 'Federico A.',
    location: 'Uruguay',
    product: 'Compró el MEGAPACK',
    text: 'Ya me estaba quedando sin ideas y este megapack me vino bárbaro. Las sesiones son completas, variadas y con adaptaciones para distintos niveles.',
    bg: 'bg-blue-600',
  },
]
